var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        [
          _c(
            "div",
            { staticClass: "mb10" },
            [
              _c(
                "v-button",
                {
                  attrs: { type: "primary", name: "" },
                  on: { click: _vm.showNewModel },
                },
                [_vm._v("创建Topic")]
              ),
            ],
            1
          ),
          _c(
            "div",
            [
              _c(
                "vxe-table",
                {
                  attrs: {
                    "row-id": "id",
                    data: _vm.table,
                    align: "left",
                    "row-style": _vm.setRowClass,
                  },
                },
                [
                  _c("vxe-table-column", {
                    attrs: {
                      field: "topic",
                      "show-overflow": "",
                      "min-width": "320",
                      title: "topic",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "created_at",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "创建时间",
                    },
                  }),
                  _c("vxe-table-column", {
                    attrs: {
                      field: "updated_at",
                      "show-overflow": "",
                      "min-width": "120",
                      title: "更新时间",
                    },
                  }),
                  _c("vxe-column", {
                    attrs: { title: "操作", "min-width": "120" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "span",
                              { staticClass: "handle-button" },
                              [
                                _c(
                                  "v-button",
                                  {
                                    attrs: {
                                      slot: "reference",
                                      size: "S",
                                      type: "text",
                                      name: "btn2",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.showDelModel(slotProps.row)
                                      },
                                    },
                                    slot: "reference",
                                  },
                                  [_vm._v("删除")]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.total
            ? _c("v-pagination", {
                attrs: {
                  total: _vm.total,
                  name: "page-basic",
                  "is-show-total": "",
                  "is-change-size": "",
                  "is-input-page": "",
                  "current-page": this.currentPage,
                },
                on: {
                  "change-page": _vm.changePage,
                  "change-size": _vm.changeSize,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c("New", {
        ref: "New",
        attrs: { showInputDialog: _vm.Newloading, sourceId: _vm.sourceId },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Newloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Newloading = $event
          },
          getData: _vm.getData,
        },
      }),
      _c("Del", {
        ref: "Del",
        attrs: { showInputDialog: _vm.Delloading, Id: _vm.Id },
        on: {
          "update:showInputDialog": function ($event) {
            _vm.Delloading = $event
          },
          "update:show-input-dialog": function ($event) {
            _vm.Delloading = $event
          },
          getData: _vm.getData,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }